import { startGetListPendingInvoices } from "../../actions/lessee";
import ErrorMessage from "../ErrorMessage";
import LoadingMessage from "../LoadingMessage";
import PendingInvoice from "./PendingInvoice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

function ListPendingInvoices() {
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state) => state.lessee.lessee.listPendingInvoices.loading
  );
  const loadedListPendingInvoices = useSelector(
    (state) => state.lessee.lessee.listPendingInvoices.data
  );
  const errorDesc = useSelector(
    (state) => state.lessee.lessee.listPendingInvoices.error
  );

  useEffect(() => {
    dispatch(startGetListPendingInvoices());
  }, []);

  if (isLoading) {
    return <LoadingMessage></LoadingMessage>;
  } else if (
    loadedListPendingInvoices !== undefined &&
    loadedListPendingInvoices != null &&
    loadedListPendingInvoices.length >= 0
  ) {
    return (
      <section className="slice sct-color-1">
        <div className="container">
          <div className="row-wrapper">
            <div className="row">
              <div className="fluid-paragraph fluid-paragraph-sm c-gray-light strong-600 text-center">
                <h2 className="heading heading-5 strong-500">
                  Facturas Pendientes
                </h2>
                <hr></hr>
              </div>
              {loadedListPendingInvoices.map((pendingInvoice) => (
                <>
                  <PendingInvoice
                    key={pendingInvoice.id}
                    data={pendingInvoice}
                  />
                  <hr></hr>
                </>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <>
        <ErrorMessage message={errorDesc} />
      </>
    );
  }
}

export default ListPendingInvoices;
